import { useCallback, useState } from "react"
import { useModalContext } from "../context/ModalContext"
import { Alert, Button, Input, Modal, Form } from "antd"
import '../assets/css/Prijava.css'
import noRefreshClient, { setMessageBasedOnErrorMessage } from "../services/api/NoRefreshClient"
import { MODAL_DESCRIPTION_SUCCESS_REQUEST_RESET_PASS, MODAL_MESSAGE_SUCCESS_REQUEST, MODAL_TYPE_SUCCESS, OK_RESPONSE } from "../HistoriografijaConstants"

function EmailInput() {
    const [showWarning, setShowWarning] = useState(false)
    const [error, setError] = useState(String)
    const { displayMessageModalWithParameters, displayGenericErrorModal, resetModalContext, displayPrijavaModal } = useModalContext()
    const [form] = Form.useForm()

    const onClose = useCallback(() => {
        resetModalContext()
    }, [resetModalContext])

    const submitForm = useCallback((values) => {
        form.validateFields({validateOnly: true})
        .then(async () => {
            var formData = new FormData();
            formData.append("email", values.email)
            return noRefreshClient.post('users/requestResetPassword', formData)
            .then(data => {
                if (data.status === 200) {
                    if (data.data === OK_RESPONSE) {
                        displayMessageModalWithParameters(MODAL_MESSAGE_SUCCESS_REQUEST, MODAL_DESCRIPTION_SUCCESS_REQUEST_RESET_PASS, MODAL_TYPE_SUCCESS)
                    }
                } else {
                    displayGenericErrorModal()
                }
            })
            .catch(error => {
                setMessageBasedOnErrorMessage(error)
                setError(error.message)
                setShowWarning(true)
            })
    })}, [form, displayMessageModalWithParameters, displayGenericErrorModal, setError, setShowWarning])

    const openPrijavaModal = useCallback(() => {
        displayPrijavaModal()
    }, [displayPrijavaModal])

    return (
        <Modal 
            open={true}
            footer={null}
            onCancel={onClose}
            centered
        >
            <div className="Prijava">
                <div className="PrijavaForm">
                    <Form form={form} onFinish={submitForm} className="Form" noValidate scrollToFirstError>
                        <h2 className="FormTitle">RESET LOZINKE</h2>

                        <Form.Item name="email"
                            className="formItem"                    
                            rules={[
                                {
                                    required: true,
                                    message: 'Email je obavezno polje',
                                },
                                {
                                    type: 'email',
                                    message: 'Email adresa nije u ispravnom formatu',
                                    validateTrigger: 'onBlur'
                                }
                            ]}>
                            <Input placeholder="Email" className="inputField" type="email"/>
                        </Form.Item>

                        {showWarning ?
                            <Alert
                                message="Greška"
                                description={error}
                                type="error"
                                style={{ marginBottom: '20px', marginTop: '20px' }}
                                showIcon
                            /> : null
                        }

                        <Form.Item>
                            <Button htmlType="submit" className="login-form-button custom-button primaryButton">
                                POŠALJI EMAIL
                            </Button>
                        </Form.Item>

                        <Form.Item>
                            <Button onClick={openPrijavaModal} className="login-form-button custom-button secondaryButton button-as-link">
                                Povratak na prijavu
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </Modal>
    )
}

export default EmailInput